import { render, staticRenderFns } from "./TextInfo.vue?vue&type=template&id=8de8b58c&scoped=true&"
import script from "./TextInfo.vue?vue&type=script&lang=js&"
export * from "./TextInfo.vue?vue&type=script&lang=js&"
import style0 from "./TextInfo.vue?vue&type=style&index=0&id=8de8b58c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de8b58c",
  null
  
)

export default component.exports